module.exports = __webpack_public_path__ + "static/media/cao-hac-sam-4.4d1a3f8f.jpg";